import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=1422bbf5&scoped=true"
var script = {}
import style0 from "./HomeView.vue?vue&type=style&index=0&id=1422bbf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422bbf5",
  null
  
)

export default component.exports